import { Dates } from 'helpers';
import { DisplaySalesOrder, SalesOrderType } from 'services/salesOrders/types';
import { Pagination } from 'services/search';

export interface SalesOrderSearchResultsProps {
  salesOrders: DisplaySalesOrder[];
  pagination: Pagination;
  onPaginationChange: (pagination: Pagination) => void;
  activeSalesOrderId: null | number;
  handleSalesOrderClick: (salesOrderId: number) => Promise<void>;
  onAction: (type: SalesOrderTableRowActions, value: any) => void;
  onAddNewPress(): void;
  isLoadingSalesOrders: boolean;
  selectedItems: number[];
  activeSalesOrderDate: Dates;
  setSelectedItems: (ids: number[]) => void;
  onDeleteClicked: () => void;
  onPageAction: (type: SalesOrderPageAction, date?: Dates) => void;
  onUnissueClicked: () => void;
  onIssueClicked: () => void;
  onBulkQuickFulfillClicked: (selectedOrderIds: number[]) => void;
  showBulkQuickFulfillButton?: boolean;
  activeUser: any;
}

export enum SalesOrderTableRowActions {
  Duplicate,
  Delete,
}

export enum SalesOrderPageAction {
  Export,
  Import,
  CustomFields,
  ShowReport,
  ChangeDate,
  DeleteMultiple,
  Unissue,
  Issue,
}

export interface OrderTypeLabelProps {
  orderType: SalesOrderType | null;
}
